import api from './api';

export type ActivityEvent = 'all' | 'sign_ins' | 'login_requests' | 'errors';
export interface ActivityFilters {
  hours: number;
  event: ActivityEvent;
  status?: number;
  search: string;
  limit: number;
  offset: number;
}
export interface ActivityRow {
  id: number;
  timestamp: string;
  method: string;
  endpoint_path: string;
  status_code: number | null;
  response_time_ms: number | null;
  ip_address: string | null;
  user_agent: string | null;
  event: string;
}
export interface ActivityResponse {
  items: ActivityRow[];
  total: number;
  limit: number;
  offset: number;
  summary: { requests: number; sign_ins: number; login_requests: number; errors: number; last_activity_at: string | null };
  generated_at: string;
  window_start: string;
  last_logged_at: string | null;
  environment: string;
}
export async function getGwiMoveActivity(filters: ActivityFilters, signal?: AbortSignal): Promise<ActivityResponse> {
  const { data } = await api.get<ActivityResponse>('/admin/gwimove-activity', { params: filters, signal });
  return data;
}
